import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useFormContext } from 'react-hook-form';
import { Input, Select } from '_components';
import { _ } from '_locales';
import { colors } from '_styles';
import ErrorText from './ErrorText';
import { formatPhoneNumber } from '../../BulkPickup/heplers';

const Title = styled.h2`
  font-size: 20px !important;
   
  margin-bottom: 20px;
  font-weight: 500 !important;
`;

const RemindingMethodHolder = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
`;

const RemindingMethodLabel = styled.label`
  cursor: pointer;
`;

const ReminderLabelText = styled.span`
  font-size: 15px !important;
  text-align: center;
  display: block;
`;

const RemindingMethodItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 150px; 
  margin: 0px 20px;
  color: rgba(0,0,0,0.6);
  cursor: pointer;
`;

const RadioInput = styled.input`
  transform:scale(1.5);
  accent-color: ${colors.RC_ACTION};
  justify-content: center;
  cursor: pointer;
`;

const RemindingMethodIcon = styled.div`
  margin: 0 auto;
  max-width: 60px;
  width: 50px;
`;

const RemindingMethodIconInner = styled.div`
  width: 100%;
  height: 60px;
  background-image: url(${({ src }) => src});
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
`;

const animation = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const InputContainer = styled.div`
  width: 70%;
  max-width: 500px;
  margin: auto;
  display: flex;
  justify-content: center;
  animation: ${animation} 2s;
`;

const countryCodes = [
  { id: 1, value: 1 },
  { id: 2, value: 61 },
  { id: 3, value: 44 },
  { id: 4, value: 64 },
];

const ReminderCommMethod = ({
  has_sms_reminder, has_phone_reminder,
  reminder, setFormattedSms, formattedSms,
  formattedPhone, setFormattedPhone
}) => {
  const isOnlyEmail = (!has_phone_reminder && !has_sms_reminder);
  const { register, watch, formState: { errors } } = useFormContext();
  const method = watch('method');
  const methodsObj = {
    email: {
      label: _('reminder.email'),
      icon: `${process.env.PUBLIC_URL}/images/reminder/email.svg`,
      key: 'email',
      isVisible: true
    },

    sms: {
      label: _('reminder.sms/text'),
      icon: `${process.env.PUBLIC_URL}/images/reminder/sms.svg`,
      key: 'sms',
      isVisible: has_sms_reminder
    },

    phone: {
      label: _('reminder.automated_phone_cal'),
      icon: `${process.env.PUBLIC_URL}/images/reminder/phone.svg`,
      key: 'phone',
      isVisible: has_phone_reminder
    }
  };

  const emailOnlyTitle = reminder === 'single'
    ? _('reminder.please_enter_your_email_address_to_get_weekly_reminder') : _('reminder.get_a_weekly_pickup_and_event_reminder');

  return (
    <div>
      <Title style={{ textAlign: 'center' }}>
        {isOnlyEmail
          ? (emailOnlyTitle)
          : (_('reminder.how_would_you_like_to_be_reminded'))}
      </Title>
      {/* Top part of Reminding Method (The Radio Buttons) */}
      {!isOnlyEmail && (
        <RemindingMethodHolder>
          {Object.values(methodsObj)
            .filter((methods) => { if (methods.isVisible) return methods; return undefined; })
            .map((methods) => (
              <RemindingMethodItem key={`${methods.key}`}>
                <RemindingMethodLabel htmlFor={methods.key}>
                  <RemindingMethodIcon>
                    <RemindingMethodIconInner src={methods.icon} />
                  </RemindingMethodIcon>
                  <ReminderLabelText>
                    {methods.label}
                  </ReminderLabelText>
                </RemindingMethodLabel>
                <RadioInput
                  aria-label={methods.label}
                  type="radio"
                  value={methods.key}
                  name="method"
                  id={methods.key}
                  style={{ marginTop: '12px' }}
                  ref={register}
                />

              </RemindingMethodItem>
            ))}
        </RemindingMethodHolder>
      )}

      {/* Bottom part of Reminding Method (The Input) */}
      {method === 'email' && (
        <InputContainer>
          <Input
            full
            name="email"
            inputRef={register}
            placeholder={_('stayInformed.enter_your_email_address')}
            variant="filled"
          />
        </InputContainer>
      )}

      {method === 'sms' && (
        <InputContainer>
          <Select
            name="areaCode"
            style={{
              width: '15%',
              height: 'auto',
              paddingLeft: '10px',
            }}
            selectRef={register}
            ariaLabel="Select phone area code"
          >
            {countryCodes.map(({ id, value }) => (
              <option value={value} key={id}>
                +
                {value}
              </option>
            ))}
          </Select>
          <Input
            type="tel"
            variant="filled"
            name="sms"
            placeholder={_('reminder.enter_your_phone_number')}
            value={formattedSms}
            onChange={(e) => {
              if (e.target.value.length < 19) {
                setFormattedSms(formatPhoneNumber(e.target.value));
              }
            }}
            style={{ marginLeft: '10px' }}
          />
        </InputContainer>
      )}

      {method === 'phone' && (
        <InputContainer>
          <Select
            name="areaCode"
            style={{
              width: '15%',
              height: 'auto',
              paddingLeft: '10px',
            }}
            selectRef={register}
            ariaLabel="Select phone area code"
          >
            {
              countryCodes.map(({ id, value }) => (
                <option value={value} key={id}>
                  +
                  {value}
                </option>
              ))
            }
          </Select>

          <Input
            type="tel"
            name="phone"
            variant="filled"
            placeholder={_('reminder.enter_your_phone_number')}
            value={formattedPhone}
            onChange={(e) => {
              if (e.target.value.length < 19) {
                setFormattedPhone(formatPhoneNumber(e.target.value));
              }
            }}
            style={{ marginLeft: '10px' }}
          />
        </InputContainer>
      )}

      {errors[method] && (
        <InputContainer>
          <ErrorText>
            {errors[method].message}
          </ErrorText>
        </InputContainer>
      )}

    </div>
  );
};

export default ReminderCommMethod;
